import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
	font-size: 16px;
	line-height: 20px;
	position: relative;
	margin-bottom: 15px;
	font-weight: 500;
	letter-spacing: 0.5px;
	color: ${props => 
		props.variant === "blue" ? "#0d609d" :
		props.variant === "white" ? "#ffffff" :
		"#000000"
	};

	&:before{
		content: "";
		top: 0px;
		left: -30px;
		display: block;
		position: absolute;
		width: 8px;
		height: 100%;
		background-color: ${props => 
			props.variant === "blue" ? "#0d609d" :
			props.variant === "white" ? "#ffffff" :
			"#000000"
		};
	}
`;


const SubSectionTitle = ({title, variant = "blue"}) => {
  return (
    <Wrapper>
		<Title variant={variant}>{title}</Title>        
    </Wrapper>
  )
}

export default SubSectionTitle;
